import { appVariant } from '../config';

/** Pack used for bonus puzzle images: local assets under public/assets/bonus/{pack}/. */
type BonusPack = 'blitz' | 'party' | 'family' | 'team';

/** Number of local puzzle images per pack: public/assets/bonus/{pack}/{pack}-bonus-puzzle-1.jpg … N.jpg. Use 0 to fall back to blitz. */
const PUZZLE_IMAGE_COUNT_BY_PACK: Record<BonusPack, number> = {
  blitz: 30,
  party: 6,
  family: 6,
  team: 7,
};

function getBonusPack(): BonusPack {
  if (appVariant === 'blitz' || appVariant === 'party' || appVariant === 'family' || appVariant === 'team') {
    return appVariant;
  }
  return 'blitz';
}

/** Random local puzzle image URL for the current app variant (same pack as BonusHostScreen). */
export function getRandomPuzzleImageUrl(): string {
  const pack = getBonusPack();
  let count = PUZZLE_IMAGE_COUNT_BY_PACK[pack];
  const usePack = count > 0 ? pack : 'blitz';
  count = count > 0 ? count : PUZZLE_IMAGE_COUNT_BY_PACK.blitz;
  const n = 1 + Math.floor(Math.random() * count);
  return `/assets/bonus/${usePack}/${usePack}-bonus-puzzle-${n}.jpg`;
}
